const EVENT = 'workloop:desktop-boot';

export const emitDesktopBoot = (detail = {}) => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(EVENT, { detail }));
};

export const subscribeDesktopBoot = (onEvent) => {
  if (typeof window === 'undefined') return () => {};
  const handler = (event) => onEvent(event.detail || {});
  window.addEventListener(EVENT, handler);
  return () => window.removeEventListener(EVENT, handler);
};
